import { useContext } from 'react';
import ThemeContext from '../../store/theme-context';
import Card from "../UI/Card";
import { useNavigate } from 'react-router-dom';

const Blogs = ({blogs}) => {
    const navigate = useNavigate();
    const theme = useContext(ThemeContext);
    return ( 
        <div className="cards-row blog-card">
           {blogs && blogs.map((item)=>
           (<Card key={item.id} className="cardBody" onClick={()=>window.open(`${item.URL}`, '_blank')}>
               <div className="card-items">
                <div className="blogImages" style={{borderColor: theme.currentTheme.borderColor, boxShadow: theme.currentTheme.boxShadow}}>
                    {item.photo && <img src={item.photo} alt="blog icon" />}
                </div>
               <h3 title={item.title}>{`${item.title.substring(0, 60).trim()}...`}</h3>
               <p title={item.description}>{`${item.description.substring(0, 100).trim()}...`}</p>
               </div>
            </Card>)
           )}
        </div>
     );
}
 
export default Blogs;